import DoctorAppointments from 'Pages/Doctor/DoctorAppointments';
import PendingDetail from 'Pages/Doctor/DoctorAppointments/PendingDetail';
import RequestDetails from 'Pages/Doctor/DoctorAppointments/RequestDetails';
import UpcomingDetails from 'Pages/Doctor/DoctorAppointments/UpcomingDetails';
import DoctorDashboard from 'Pages/Doctor/DoctorDashboard';
import PatientList from 'Pages/Doctor/DoctorPatient';
import PatientDetail from 'Pages/Doctor/DoctorPatient/DoctorPatientDetail';
import DoctorProfile from 'Pages/Doctor/DoctorProfile';
import MyEarning from 'Pages/Doctor/DoctorProfile/MyEarning';
import DoctorSchedule from 'Pages/Doctor/DoctorSchedule';
import DoctorSubscription from 'Pages/Doctor/DoctorSubscription';
import DoctorCancel from 'Pages/Doctor/DoctorSubscription/DoctorCancel';
import DoctorChangePlan from 'Pages/Doctor/DoctorSubscription/DoctorChangePlan';
import DoctorPaymet from 'Pages/Doctor/DoctorSubscription/DoctorPayment';
import Login from 'Pages/Login';
import PaymentSuccess from 'Pages/PaymentSuccess';
import RegisterMethod from 'Pages/Register';
import RegisterFinalStep from 'Pages/registerFinalStep';
import RegisterProfessionalDetail from 'Pages/RegisterProfessionalDetail';
import RegisterSuccess from 'Pages/RegisterSuccess';
import RegistrationStepOne from 'Pages/RegistrationStepOne';
import RegistrationStepThree from 'Pages/RegistrationStepThree';
import {
  login,
  register,
  registrationOne,
  doctorDashboard,
  registerProfessionalDetail,
  registerContractDetail,
  registerSuccess,
  doctorSchedule,
  doctorAppointments,
  registerFinal,
  doctorPatient,
  doctorProfile,
  doctorSubscription,
  doctorPatientDetails,
  doctorAppointmentsRequestDetails,
  doctorAppointmentsUpcomingDetails,
  doctorAppointmentsPendingDetails,
  doctorCancelWeb,
  doctorEarning,
  paymentSuccess,
} from 'routes/AppUrls';

const publicRoutes = [
  {
    path: (locale) => login(locale),
    element: <Login />,
    isNoSidebar: true,
    isNoNavbar: true,
  },
  {
    path: (locale) => register(locale),
    element: <RegisterMethod />,
    isNoSidebar: true,
    isNoNavbar: true,
  },
  {
    path: (locale) => registerSuccess(locale),
    element: <RegisterSuccess />,
    isNoSidebar: true,
    isNoNavbar: true,
  },
  {
    path: (locale) => registrationOne(locale),
    element: <RegistrationStepOne />,
    isNoSidebar: true,
    isNoNavbar: true,
  },
  {
    path: (locale) => registerProfessionalDetail(locale),
    element: <RegisterProfessionalDetail />,
    isNoSidebar: true,
    isNoNavbar: true,
  },
  {
    path: (locale) => registerContractDetail(locale),
    element: <RegistrationStepThree />,
    isNoSidebar: true,
    isNoNavbar: true,
  },
  {
    path: (locale) => registerFinal(locale),
    element: <RegisterFinalStep />,
    isNoSidebar: true,
    isNoNavbar: true,
  },
];

const privateRoutes = [
  {
    path: (locale) => doctorDashboard(locale),
    element: <DoctorDashboard />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale) => doctorSchedule(locale),
    element: <DoctorSchedule />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale) => doctorAppointments(locale),
    element: <DoctorAppointments />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale) => doctorAppointmentsRequestDetails(locale),
    element: <RequestDetails />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale) => doctorAppointmentsUpcomingDetails(locale),
    element: <UpcomingDetails />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale) => doctorAppointmentsPendingDetails(locale),
    element: <PendingDetail />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale) => doctorPatient(locale),
    element: <PatientList />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale) => doctorPatientDetails(locale),
    element: <PatientDetail />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale) => doctorProfile(locale),
    element: <DoctorProfile />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale) => doctorEarning(locale),
    element: <MyEarning />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale) => doctorSubscription(locale),
    element: <DoctorSubscription />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  // doctorCancelWeb
  {
    path: (locale) => doctorCancelWeb(locale),
    element: <DoctorCancel />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale) => '/:locale/doctor-cancel/:token',
    element: <DoctorCancel />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale, id) => '/:locale/doctor-change-plan/:id/:token',
    element: <DoctorChangePlan />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale, id) => '/:locale/doctor-payment/:value/:token',
    element: <DoctorPaymet />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
  {
    path: (locale) => paymentSuccess(locale),
    element: <PaymentSuccess />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
];

const commonRoutes = [
  {
    path: (locale) => doctorDashboard(locale),
    element: <DoctorDashboard />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: true,
    isPrivate: true,
  },
];

export const allRoutes = [...publicRoutes, ...privateRoutes, ...commonRoutes];
